var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13947"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13948"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD328\\uC2A4 18610",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.922 0A18.922 18.922 0 1 1 0 18.922 18.922 18.922 0 0 1 18.922 0z",
    style: {
      stroke: "none"
    },
    transform: "translate(3.977 1.818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.922 3A15.818 15.818 0 0 0 7.663 7.663 15.818 15.818 0 0 0 3 18.922c0 4.253 1.656 8.251 4.663 11.258a15.818 15.818 0 0 0 11.259 4.664c4.253 0 8.251-1.656 11.258-4.664a15.818 15.818 0 0 0 4.664-11.258c0-4.253-1.656-8.251-4.664-11.259A15.818 15.818 0 0 0 18.922 3m0-3c10.45 0 18.922 8.472 18.922 18.922 0 10.45-8.472 18.922-18.922 18.922C8.472 37.844 0 29.372 0 18.922 0 8.472 8.472 0 18.922 0z",
    style: {
      fill: "#fff",
      stroke: "none"
    },
    transform: "translate(3.977 1.818)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18611",
    d: "m0 0 10.04 10.813",
    transform: "translate(34.484 33.869)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 3,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "9782d838133663839665943c222e67d6",
    d: "M15.872 13.995 20.6 9.279a1.338 1.338 0 1 0-1.892-1.892l-4.714 4.729L9.28 7.388a1.338 1.338 0 0 0-1.892 1.891l4.728 4.715-4.728 4.716A1.338 1.338 0 1 0 9.28 20.6l4.714-4.729 4.715 4.729a1.338 1.338 0 1 0 1.891-1.89z",
    transform: "translate(9.006 7.004)",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIco);
export default __webpack_public_path__ + "static/media/no_data_ico.33df721fce755c2b9bbe56d57fee5acd.svg";
export { ForwardRef as ReactComponent };